/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Stack, Grid2, Container } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

import "./AppDetailsInfo.css";
import { useSelector } from "react-redux";

function AppDetailsInfo({
  categoryData,
  submissionData,
  languageData,
  teamsData,
  postCallTheNewSubmission,
}) {
  const [currentCategoryValue, setCurrentCategoryValue] = useState([]);
  const [currentDefaultLanguage, setcurrentDefaultLanguage] = useState({});
  const [applicationName, setApplicationName] = useState("");
  const currentLanguageInUse = useSelector(
    (state) => state.languageDetails.currentLanguage
  );

  useEffect(() => {
    if (submissionData && Object.keys(submissionData).length > 0) {
      setApplicationName(submissionData.descriptions[0].applicationName);
    }
  }, [submissionData]);

  useEffect(() => {
    let applicationNameCurrentLanguage = "";
    if (submissionData && Object.keys(submissionData).length > 0) {
      submissionData.descriptions.map((ele) => {
        if (ele.language === currentLanguageInUse) {
          applicationNameCurrentLanguage = ele.applicationName;
        }
      });
    }
    setApplicationName(
      applicationNameCurrentLanguage == null
        ? ""
        : applicationNameCurrentLanguage
    );
  }, [currentLanguageInUse]);

  useEffect(() => {
    let currentValue = categoryData.filter((catgry, index) => {
      let indx =
        submissionData &&
        Object.keys(submissionData).length > 0 &&
        submissionData.categoryIds.indexOf(catgry.id);
      if (indx >= 0) {
        return catgry;
      }
    });
    setCurrentCategoryValue(currentValue);

    let defaultLanguageData = languageData.filter((lng, index) => {
      if (lng.languageTag === submissionData.defaultLanguage) {
        return lng;
      }
    });
    setcurrentDefaultLanguage(...defaultLanguageData);
  }, [categoryData, submissionData, languageData, teamsData]);

  const handleChange = ($event) => {
    const newCategoryIds = [];
    categoryData.filter((ctgry, index) => {
      if (
        $event.target.value.includes(ctgry.translatedNames[submissionData.defaultLanguage]===undefined ? ctgry.translatedNames["en-US"] : ctgry.translatedNames[submissionData.defaultLanguage])
      ) {
        newCategoryIds.push(ctgry);
      }
    });
    setCurrentCategoryValue(newCategoryIds);
    let newSubmissionData = {
      ...submissionData,
      categoryIds: [newCategoryIds[0].id],
    };
    delete newSubmissionData.legalDocuments;
    newSubmissionData.icon = null;
    newSubmissionData.descriptions[0].banner = null;
    newSubmissionData.descriptions[0].screenshots = [];
    newSubmissionData.categories = [...newSubmissionData.categoryIds];
    delete newSubmissionData.categoryIds;
    postCallTheNewSubmission(newSubmissionData);
  };

  const changeApplicationName = ($event) => {
    setApplicationName($event.target.value);
  };

  const changeApplicationNameinSubmission = () => {
    let newSubmissionData = {
      ...submissionData,
    };
    delete newSubmissionData.legalDocuments;
    let descriptions = [...newSubmissionData.descriptions];
    descriptions.forEach((ele) => {
      if (ele.language === currentLanguageInUse) {
        ele.applicationName = applicationName;
      }
    });
    newSubmissionData.descriptions = [...descriptions];
    delete newSubmissionData.categoryIds;
    postCallTheNewSubmission(newSubmissionData);
  };

  const getCategoryTranslatedName = (category) => {
    if (category.translatedNames[submissionData.defaultLanguage]) {
      return category.translatedNames[submissionData.defaultLanguage];
    }
    return category.translatedNames["en-US"];
  };

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start" alignItems="center">
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <section id="app-info" className="app-info-section">
            {categoryData.length === 0 &&
            Object.keys(submissionData).length === 0 &&
            languageData.length === 0 ? (
              <LinearProgress />
            ) : (
              <>
                {
                  <div>
                    <Stack direction="row" spacing={2}>
                      <div className="input-div-app-info">
                        <p className="label-app-info">
                          Application Name <span className="required">*</span>
                        </p>
                        <TextField
                          sx={{ width: "260px" }}
                          className="input-field"
                          id="outlined-basic"
                          type="text"
                          variant="outlined"
                          value={applicationName}
                          onChange={($event) => changeApplicationName($event)}
                          onBlur={() => changeApplicationNameinSubmission()}
                          required
                        />
                      </div>
                      <div className="input-div-app-info">
                        <p className="label-app-info">
                          Category <span className="required">*</span>
                        </p>
                        <Select
                          className="input-field"
                          sx={{ border: "none !important" }}
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          value={
                            currentCategoryValue.length > 0
                              ? getCategoryTranslatedName(currentCategoryValue[0])
                              : ""
                          }
                          onChange={handleChange}
                          variant="outlined"
                        >
                          {categoryData.map((item) => {
                            return (
                              <MenuItem
                                key={item.id}
                                value={getCategoryTranslatedName(item)}
                              >
                                {getCategoryTranslatedName(item)}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                      <div className="input-div-app-info">
                        <p className="label-app-info">
                          Default language <span className="required">*</span>
                        </p>
                        <TextField
                          className="input-field"
                          id="outlined-basic"
                          type="text"
                          variant="outlined"
                          value={currentDefaultLanguage.defaultName}
                          slotProps={{
                            input: {
                              readOnly: true,
                            },
                          }}
                          disabled
                          required
                        />
                      </div>
                      <div className="input-div-app-info">
                        <p className="label-app-info">
                          Associate Team <span className="required">*</span>
                        </p>
                        <TextField
                          className="input-field"
                          id="outlined-basic"
                          type="text"
                          variant="outlined"
                          value={teamsData.name}
                          slotProps={{
                            input: {
                              readOnly: true,
                            },
                          }}
                          disabled
                          required
                        />
                      </div>
                    </Stack>
                  </div>
                }
              </>
            )}
          </section>
        </Grid2>
      </Grid2>
    </Container>
  );
}

AppDetailsInfo.propTypes = {
  categoryData: PropTypes.array.isRequired,
  submissionData: PropTypes.object.isRequired,
  languageData: PropTypes.array.isRequired,
  teamsData: PropTypes.object.isRequired,
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default AppDetailsInfo;
